import { ManagePreferencesPage } from './pages/ManagePreferences';
import { OneClickUnsubscribePage } from './pages/OneClickUnsubscribe';
import { CATEGORY_BY_ID, type CategoryId } from './types';

function pickPage() {
  const params = new URLSearchParams(window.location.search);
  const unsubscribe = params.get('unsubscribe');

  if (unsubscribe && unsubscribe in CATEGORY_BY_ID) {
    return { kind: 'one-click' as const, categoryId: unsubscribe as CategoryId };
  }

  return { kind: 'manage' as const };
}

export function App() {
  const page = pickPage();

  if (page.kind === 'one-click') {
    return <OneClickUnsubscribePage categoryId={page.categoryId} />;
  }

  return <ManagePreferencesPage />;
}
